import { defineStore } from 'pinia';
import type { IGachaInfoRes, Gacha } from '@/apis/gacha';
import type { BeforeInstallPromptEvent } from '@vite-pwa/nuxt/dist/runtime/plugins/types.js';

const { cache } = useCache('local')

type UserInfo = {
  preserved?: boolean,
  store?: boolean,
  facebook?: boolean,
}

type PhoneInfo = {
  area: string,
  mobile: string
}

export type UserState = {
  userInfo: UserInfo,
  phoneInfo: PhoneInfo
  phonenum: string,
  gachaInfo: IGachaInfoRes,
  firstGacha: Gacha[],
  deferredPrompt: BeforeInstallPromptEvent,
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      phonenum: cache.get('phonenum') || '',
      userInfo: {
        preserved: false,
        store: false,
        facebook: false
      },
      phoneInfo: {
        mobile: '',
        area: ''
      },
      gachaInfo: JSON.parse(cache.get('gachaInfo')) || {
        items: [],
        available_gacha_num: '1',
        used_gacha_num: '0',
        share_facebook: '0',
        reserved: false,
        share_link: '',
        mobile: '',
        share_count: '0',
        f5: ''
      },
      firstGacha: [],
      deferredPrompt: null,
    }
  },
  actions: {
    setPhonenum(phonenum: string) {
      this.phonenum = phonenum;
      this.userInfo = JSON.parse(cache.get(phonenum)) || {
        preserved: true,
        store: false,
        facebook: false
      }
      cache.set('phonenum', phonenum)
      cache.set(phonenum, JSON.stringify(this.userInfo))
    },
    setPhoneInfo(info: PhoneInfo) {
      Object.assign(this.phoneInfo, info)
      this.setPhonenum(info.area + info.mobile)
    },
    setUserInfo(userInfo: UserInfo) {
      Object.assign(this.userInfo, userInfo)
      cache.set(this.phonenum, JSON.stringify(this.userInfo))
    },
    setGachaInfo(gachaInfo: IGachaInfoRes) {
      Object.assign(this.gachaInfo, gachaInfo)
      cache.set('gachaInfo', JSON.stringify(gachaInfo))
    },
    setFirstGacha(items: Gacha[]) {
      this.firstGacha = items
    },
    setDeferredPrompt(e: BeforeInstallPromptEvent){
      this.deferredPrompt=e
    }
  }
})